var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{attrs:{"cols":"12","md":_vm.md}},[_c('v-card-title',{staticStyle:{"color":"#213B87","font-size":"12pt"}},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('v-card-subtitle',[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }